<template>
  <el-dialog
      :visible="true"
      :close-on-click-modal="false"
      :before-close="handleClose"
      width="1300px"
  >

    <el-card>
      <div slot="header" class="clearfix">
        <span>Számlák kiválasztása</span>
      </div>
      <el-form style="display: flex">
        <el-form-item
            label="Képviselő"
        >
          <el-select
              v-model="representativeUserId"
              v-loading="userLoading"
              filterable
              @change="fetchRepresentativeSales"
          >
            <el-option
                v-for="user in representativeUsers"
                :key="user.id"
                :value="user.id"
                :label="user.full_name"
            />
          </el-select>
        </el-form-item>

        <el-form-item
            label="Bizonylat szám"
            style="margin-left: 10px;"
        >
          <el-input
              label="Teszt"
              style="width: 200px;"
              v-model="receiptNumber"
              class="filter-input"
          >
          </el-input>
        </el-form-item>
      </el-form>


      <el-row :gutter="20">
        <el-col>
          <el-table
              v-loading="representativeSalesLoading"
              :data="filteredRepresentativeSales"
              stripe
              style="width: 100%"
              @selection-change="handleSelectionChange"
          >
            <el-table-column
                type="selection"
                width="55">
            </el-table-column>
            <el-table-column
                prop="representative_user_name"
                label="Képviselő"
            >
            </el-table-column>
            <el-table-column
                prop="receipt_number"
                label="Bizonylat"
            >
            </el-table-column>
            <el-table-column
                align="right">
              <template slot="header" slot-scope="scope">
                <el-button
                    type="success"
                    size="mini"
                    @click="selectRepresentativeSales">
                  Kijelöltek beérkeztetése
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-col>
      </el-row>
    </el-card>

    <el-row style="margin-top: 20px">
      <el-col>
        <el-card>
          <div slot="header" class="clearfix">
            <span>Beérkeztetés</span>
          </div>
          <el-table
              v-loading="invoiceReceiptReceivesLoading"
              :data="selectedRepresentativeSales"
              stripe
              style="width: 100%">
            <el-table-column
                prop="representative_user_name"
                label="Képviselő"
            >
            </el-table-column>
            <el-table-column
                prop="receipt_number"
                label="Bizonylat"
            >
            </el-table-column>
            <el-table-column
                prop="second_copy_received"
                label="Második példány">
              <template slot-scope="scope">
                <el-date-picker
                    value-format="yyyy-MM-dd"
                    :clearable="false"
                    v-if="isTypeSecond"
                    v-model="scope.row.second_copy_receive_date"
                    type="date"
                    placeholder="Beérkezés dátuma">
                </el-date-picker>

                <span v-else>
                  <span v-if="scope.row.second_copy_receive_date">
                    {{ scope.row.second_copy_receive_date }}
                  </span>
                  <span v-else>-</span>
                </span>
              </template>
            </el-table-column>
            <el-table-column
                prop="second_copy_received"
                label="Harmadik példány">
              <template slot-scope="scope">
                <el-date-picker
                    value-format="yyyy-MM-dd"
                    :clearable="false"
                    v-if="isTypeThird"
                    v-model="scope.row.third_copy_receive_date"
                    type="date"
                    placeholder="Beérkezés dátuma">
                </el-date-picker>

                <span v-else>
                  <span v-if="scope.row.third_copy_receive_date">
                    {{ scope.row.third_copy_receive_date }}
                  </span>
                  <span v-else>-</span>
                </span>
              </template>
            </el-table-column>
            <el-table-column
                width="120px"
            >
              <template slot-scope="scope">
                <el-button size="mini" type="danger" icon="el-icon-circle-close"
                           @click="removeFromSelection(scope.row.representative_sale_id)">Mégse
                </el-button>
              </template>
            </el-table-column>
          </el-table>

          <el-row>
            <el-button style="float:right; margin-top: 10px" type="primary" @click="store">Mentés</el-button>
          </el-row>
        </el-card>
      </el-col>
    </el-row>
  </el-dialog>
</template>

<script>

  export default {
    components: {},
    props: [],
    data() {
      return {
        loading: false,
        buttonLoading: false,
        representativeSales: [],
        representativeUsers: [],
        representativeUserId: null,
        representativeSalesLoading: false,
        receiptNumber: '',
        userLoading: false,
        selectedRepresentativeSales: [],
        query: null,
        invoiceReceiptReceivesLoading: false,
      };
    },
    computed: {
      preSelectedRepresentativeSales() {
        return this.representativeSales.filter(i => i.selected);
      },

      representativeSalesWithoutSelected() {
        return this.representativeSales.filter(r => {
          let show = true;
          this.selectedRepresentativeSales.forEach(s => {
            if (s.representative_sale_id === r.representative_sale_id) {
              show = false;
            }
          })
          return show;
        })
      },

      filteredRepresentativeSales() {
        return this.representativeSalesWithoutSelected.filter(data => data.receipt_number.toLocaleLowerCase()
          .indexOf(this.receiptNumber.toLocaleLowerCase()) !== -1);
      },

      isTypeSecond() {
        return this.$route.params.type === 'second';
      },

      isTypeThird() {
        return this.$route.params.type === 'third';
      }
    },
    async mounted() {
      this.userLoading = true;
      try {
        this.representativeUsers = await axios.get('api/users/representatives');
      } catch (e) {
      }
      this.userLoading = false;
    },
    methods: {

      handleClose() {
        this.$store.dispatch('invoiceReceiptReceives/fetchAll');
        this.$router.replace('/representative-processes/receipt-receives/invoice');
      },

      async store() {
        this.invoiceReceiptReceivesLoading = true;
        await axios.post('/api/invoice-receipt-receives', {
          type: this.$route.params.type,
          items: this.selectedRepresentativeSales
        })
        this.selectedRepresentativeSales = [];
        this.fetchRepresentativeSales();
        this.invoiceReceiptReceivesLoading = false;
      },

      handleSelectionChange(items) {
        this.representativeSales.forEach(r => {
          r.selected = false;
        })

        items.forEach(i => {
          this.representativeSales.forEach(r => {
            if (r.representative_sale_id === i.representative_sale_id) {
              r.selected = true;
            }
          })
        })
      },

      selectRepresentativeSales() {
        this.selectedRepresentativeSales.push(...this.preSelectedRepresentativeSales)
      },

      async fetchRepresentativeSales() {
        this.representativeSalesLoading = true;
        this.representativeSales = await axios.get('api/invoice-receipt-receives/representative-sales?creator_user_id=' + this.representativeUserId + '&type=' + this.$route.params.type);
        this.representativeSalesLoading = false;
      },

      removeFromSelection(id) {
        this.selectedRepresentativeSales = this.selectedRepresentativeSales.filter(s => s.representative_sale_id !== id);
      }
    },
  };
</script>
